module.exports = __webpack_public_path__ + "img/grid-4.c67a8c96.svg";